import { makeStyles } from '@material-ui/styles';
import { Text, Theme } from '@bizzabo/design-system';
import cn from 'clsx';

interface InfoProps {
    title: string;
    text: string;
    isLink?: boolean;
    className?: string;
    textClassName?: string;
    onLinkClick?: () => void;
}

const Info: React.FC<InfoProps> = ({
    title,
    text,
    isLink,
    className,
    textClassName,
    onLinkClick = () => {},
}) => {
    const classes = useStyles();

    return (
        <div className={cn(className, classes.info)}>
            <Text variant="t81" className={classes.title}>
                {title}
            </Text>
            {isLink ? (
                <a
                    href={`https://${text}`}
                    target="_blank"
                    className={classes.textLink}
                    rel="noreferrer"
                    onClick={onLinkClick}
                >
                    {text}
                </a>
            ) : (
                <Text variant="t81" className={cn(textClassName, classes.text)}>
                    {text}
                </Text>
            )}
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        info: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 8,
            marginTop: 8,
        },
        title: {
            color: theme.palette.greys[500],
        },
        text: {
            margin: 0,
            color: theme.palette.greys[700],
        },
        textLink: {
            ...theme.typography.t81,
            textDecoration: 'none',
            color: theme.palette.greys[700],
        },
    }),
    { classNamePrefix: Info.name }
);

export default Info;
